import {
  DoneTradeToolService,
  PagedResultDto_CsSellItemDto,
} from '@wealthlane/api-services/wealthlane-award-service';
import { type UseQueryResult, useQuery } from 'react-query';

interface DoneTradeSellItemsFilters {
  awardType?: string;
}

const useGetCsDoneTradeSellItems = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  participantId?: string,
  companyId?: string,
  skipCount: number = 0,
  maxResultCount: number = 10,
  filters?: DoneTradeSellItemsFilters
): UseQueryResult<PagedResultDto_CsSellItemDto | undefined, unknown> => {
  const awardType = filters?.awardType;

  return useQuery(
    ['getCsDoneTradeSellItems', participantId, companyId, skipCount, maxResultCount, awardType],
    async () => {
      if (!participantId || !companyId) return undefined;
      return await handleRequest(
        DoneTradeToolService.getApiAwardApiAppCsDoneTradeToolApiAppLongShareCsLongSharesListForVendor(
          participantId,
          companyId,
          skipCount,
          maxResultCount,
          awardType
        )
      );
    },
    {
      enabled: !!participantId && !!companyId,
    }
  );
};

export default useGetCsDoneTradeSellItems;